import React, { useState } from "react";
import CloseIcon from "../../assets/Icons/CloseIcon";

function IconModal({ onClose, onSuccess, assosiatedIcons, isLoadMore, type }) {
  const [selectedIcon, setSelectedIcon] = useState(null);
  const [showAllSections, setShowAllSections] = useState(false);

  const handleIconClick = (icon) => {
    setSelectedIcon(icon);
  };

  const handleSelect = () => {
    if (selectedIcon) {
      onSuccess(selectedIcon);
    }
  };

  const renderSection = ({ icons, name }) => {
    return (
      <div key={name} className="mb-6">
        <h3 className="text-lg font-sans mb-2">{name}</h3>
        <div className="grid grid-cols-6 md:grid-cols-6 lg:grid-cols-8 gap-4 p-2">
          {icons.map((item) => {
            const Icon = item?.icon;

            return (
              <div
                key={item?.id}
                id={item.id}
                className={`border rounded cursor-pointer w-20 h-16 flex justify-center items-center ${
                  selectedIcon?.id === item.id
                    ? "border-blue-500 bg-blue-100"
                    : "border-gray-300"
                }`}
                onClick={() => handleIconClick(item)}
                onDoubleClick={() => onSuccess(item)}
              >
                <div className="icon-container">
                  <Icon className="w-12 h-12 switch-icon-color" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const getVisibleSections = (isLoadMore, showAllSections, assosiatedIcons) => {
    if (!isLoadMore) {
      return assosiatedIcons;
    }

    if (showAllSections) {
      return assosiatedIcons;
    }

    if (type == "2") {
      return assosiatedIcons.slice(0, 13);
    }

    return assosiatedIcons.slice(0, 1);
  };

  // Decide what sections to show
  const visibleSections = getVisibleSections(
    isLoadMore,
    showAllSections,
    assosiatedIcons,
    type
  );

  return (
    <div className="w-full h-screen fixed top-0 left-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-[#F3F3F5] p-6 pt-14 rounded-lg shadow-lg w-full sm:w-3/4 md:w-1/2 lg:w-2/4 relative max-h-svh overflow-y-auto">
        {/* Close Button */}
        <div
          className="absolute right-4 top-4 cursor-pointer"
          onClick={onClose}
        >
          <CloseIcon />
        </div>

        {/* Modal Title */}
        <h2 className="text-center text-lg font-semibold mb-4">
          Select an Icon
        </h2>

        {/* Icon Sections */}
        {visibleSections.map(renderSection)}

        {!showAllSections && assosiatedIcons.length > 1 && (
          <div className="text-center mt-2">
            <button
              className="text-blue-500 hover:underline text-sm"
              onClick={() => setShowAllSections(true)}
            >
              Load More Sections
            </button>
          </div>
        )}

        {/* Footer */}
        <div className="flex justify-end gap-4 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
          >
            Close
          </button>
          <button
            onClick={handleSelect}
            className={`px-4 py-2 rounded ${
              selectedIcon
                ? "bg-blue-500 text-white hover:bg-blue-600"
                : "bg-gray-400 text-gray-700 cursor-not-allowed"
            }`}
            disabled={!selectedIcon}
          >
            Select
          </button>
        </div>
      </div>
    </div>
  );
}

export default IconModal;
